import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage, withArtDirection, GatsbyImageProps } from "gatsby-plugin-image"

const imgQuery = graphql`
  {
    large: file(relativePath: { eq: "BottomCta/Zadolzhennostej/dnej180.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, quality: 80)
      }
    }
  }
`

export default function DnejImg(props: Omit<GatsbyImageProps, "image">) {
  const data = useStaticQuery(imgQuery)
  const images = withArtDirection(getImage(data.large)!, [])

  return <GatsbyImage {...props} image={images} />
}
